export const DEFAULT_PROMO_PRICING = { original: 200, discounted: 200, percentage: 0 };

type PromoCodeValue = {
  cents?: number | null;
  percentage?: number | null;
};

export function getPricingFromPromoCode(promoCode: PromoCodeValue, original = DEFAULT_PROMO_PRICING.original) {
  if (!promoCode.cents && !promoCode.percentage) {
    return DEFAULT_PROMO_PRICING;
  }

  const discounted = promoCode.percentage ? original * (1 - promoCode.percentage / 100) : original - (promoCode.cents || 0) / 100;

  return { original, discounted, percentage: ((original - discounted) / original) * 100 };
}